import { render, staticRenderFns } from "./BottomNavigation.html?vue&type=template&id=34c7f21c&scoped=true&"
import script from "./BottomNavigation.vue?vue&type=script&lang=js&"
export * from "./BottomNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavigation.scss?vue&type=style&index=0&id=34c7f21c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c7f21c",
  null
  
)

export default component.exports